











































import { Component, Vue } from "vue-property-decorator";
import { CONSOLE_SOUNDS } from "@/resources/constants/sounds";
@Component({
  name: "console-message-multi-space-component",
})
export default class ConsoleMessageMultiSpaceComponent extends Vue {
  CONSOLE_SOUNDS = CONSOLE_SOUNDS;
  sound = "NO_SOUND";
  message = "";
  loader = false;
  loading = false;
  get active(): boolean {
    return this.$store.getters[
      "FloatMenuStore/getOpenConsoleMessageMultiSpace"
    ];
  }
  set active(e: boolean) {
    this.$store.dispatch(
      "FloatMenuStore/setOpenConsoleMessageMultiSpaceAction",
      e
    );
  }
  mounted(): void {
    document.getElementById("textarea").focus();
  }
  onSelect(value: string): void {
    if (value !== "NO_SOUND") {
      const sound = this.CONSOLE_SOUNDS.filter((a) => a.name === value)[0].src;
      const audio = new Audio(sound);
      audio.autoplay = true;
      audio.play();
      setTimeout(() => {
        audio.pause();
      }, 5000);
    }
  }
  sendMessage(): void {
    const data = {
      message: this.message,
      type: "SUPER_SPACE_MESSAGE",
      color: "BLUE",
      sound: this.sound,
      hasConfirmation: true,
    };
    this.loading = true;
    this.$store.dispatch("SpaceStore/sendConsoleMessageMultiSpaceAction", {
      superSpaceId: this.$store.getters["SpaceStore/getSpace"].superSpace.id,
      data,
      callback: async () => {
        this.loading = false;
        this.message = "";
      },
    });
  }
}
